import React, { } from "react";
import Footer from "components/Footers/Footer";
import IndexNavbarr from "components/Navbars/IndexNavbarr";
import bgg2 from "assets/img/bgg2.png";
import bg from 'assets/img/bg.jpg';
import heatexchanger from "assets/img/heatexchanger.jpg";
import heatexchangerr from "assets/img/heatexchangerr.jpg";
import heatexchangerrr from "assets/img/heatexchangerrr.jpg";
import heatexchangerrrr from "assets/img/heatexchangerrrr.jpg";
import boxbg from "assets/img/boxbg.avif";
import m1 from "assets/img/m1.avif";
import m2 from "assets/img/m2.avif";
import m3 from "assets/img/m3.avif";
import m4 from "assets/img/m4.avif";
import { PilcrowSquare } from "lucide-react";

const Evoguard = () => {
    return (
        <section>
            <IndexNavbarr />
            <section className="xl:pt-0 lg:pt-0 md:pt-24 pt-20">
                <div
                    className="relative xl:h-400 lg:h-300 md:h-240 h-200-px"
                    style={{
                        backgroundImage: `url(${bgg2})`,
                        width: "100%",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        position: "relative"
                    }}
                >
                    {/* Black Overlay */}
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgba(0, 0, 0, 0.6)"
                        }}
                    ></div>

                    <div style={{ position: "relative", zIndex: 1 }}>
                        <div className="xl:gap-0">
                            <div className="xl:pt-32 lg:pt-24 md:pt-20 pt-16">
                                <h1 className="xl:text-7xl lg:text-5xl md:text-4xl text-4xl text-center text-white uppercase font-bold fade-item-1">
                                    Evoguard
                                </h1>
                                <div>
                                    <div className="flex items-center justify-center bg-[#FDF5E6] rounded-lg xl:mt-6 lg:mt-4 mt-4">
                                        <div
                                            className="xl:w-2/12 lg:w-2/12 md:w-2/12 py-2 px-2 flex items-center gap-2 justify-center fade-item-2"
                                            style={{ border: "1px dashed white" }}
                                        >
                                            <span className="text-white xl:text-lg lg:text-lg font-semibold">
                                                <a href="/homepage1">
                                                    Home
                                                </a>
                                            </span>
                                            <span className="text-white font-semibold"> »</span>
                                            <span className="text-white xl:text-lg lg:text-lg font-semibold">
                                                Evoguard
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className=""
 
>
                <div className="container mx-auto">
                
                    <div className="grid grid-cols-2 xl:py-16 gap-6">
                        <div>
                            <h1 className="xl:text-4xl text-black font-bold xl:mt-6 mt-4">Evoguard valves and pumps - high-performance technology all along the line</h1>
                            <p className="xl:text-lg tet-gray xl:mt-4 md:mt-4">Only strong and reliable components are good enough for your line. The Evoguard valve and pump series comprises a modular system of components that contributes to a high performance all over your production line.</p>
                            <p className="xl:text-lg tet-gray xl:mt-4 md:mt-4">Our comprehensive valve program offers a solution for all tasks in process technology. All valves meet high safety standards and work absolutely reliably in continuous duty.</p>
                        </div>
                        <div>
                        <div className="grid grid-cols-2 gap-6">

  <div className="relative group overflow-hidden">
    <img
      src={m1}
      alt=""
      className="w-full transform transition-transform duration-500 group-hover:scale-110"
    />

  </div>


  <div className="relative group overflow-hidden xl:mt-24">
    <img
      src={m2}
      alt=""
      className="w-full transform transition-transform duration-500 group-hover:scale-110"
    />

  </div>

  <div className="relative group overflow-hidden">
    <img
      src={m3}
      alt=""
      className="w-full transform transition-transform duration-500 group-hover:scale-110"
    />
  
  </div>


  <div className="relative group overflow-hidden xl:mt-24">
    <img
      src={m4}
      alt=""
      className="w-full transform transition-transform duration-500 group-hover:scale-110"
    />
    
  </div>
</div>

                        </div>
                    </div>
                </div>
            </section> */}

            {/* <section className="headerbg1 ">
                <div className="container mx-auto xl:py-16 py-12 xl:px-0 px-4">
                    <h6 className="text-center text-blue text-base uppercase font-semibold">
                        Portfolio
                    </h6>
                    <h3 className="text-black xl:text-4xl lg:text-3xl md:text-3xl text-2xl font-semibold text-center">
                        Everything from one Source
                    </h3>
                    <div className="grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-4 grid-cols-1 xl:pt-10 pt-10  gap-4">
                        <div className="">
                            <div className="">
                                <div className="justify-center mx-auto rounded py-4 px-2" style={{ border: '1px solid #0047ab' }}>
                                    <img src={valve} alt="" className="w-12 flex justify-center mx-auto" />
                                    <div className="xl:block lg:block md:hidden sm:hidden hidden">
                                    <p className="text-center xl:text-xl text-lg font-semibold pt-3">
                                        Valve Blocks
                                        <br></br>
                                        Automation
                                    </p>
                                    </div>
                            
                                    <div className="xl:hidden lg:hidden md:block sm:block block">
                                    <p className="text-center xl:text-xl text-lg font-semibold pt-3">
                                        Valve Blocks
                                       
                                        Automation
                                    </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="">
                            <div className="">
                                <div className="justify-center mx-auto rounded py-4 px-2" style={{ border: '1px solid #0047ab' }}>
                                    <img src={Centrifugal} alt="" className="w-12 flex justify-center mx-auto" />
                                    <div className="xl:block lg:block md:hidden sm:hidden hidden">
                                    <p className="text-center xl:text-xl text-lg font-semibold pt-3">
                                        Hygienic
                                        Centrifugal <br></br>Pump
                                    </p>
                                    </div>
                               
                                    <div className="xl:hidden lg:hidden md:block sm:block block">
                                    <p className="text-center xl:text-xl text-lg font-semibold pt-3">
                                        Hygienic
                                        Centrifugal Pump
                                    </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="">
                            <div className="">
                                <div className="justify-center mx-auto rounded py-4 px-2" style={{ border: '1px solid #0047ab' }}>
                                    <img src={Tubular} alt="" className="w-12 flex justify-center mx-auto" />
                                    <p className="text-center xl:text-xl text-lg font-semibold pt-3">
                                        Evotube
                                        Tubular Heat Exchangers
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className=" ">
                            <div className="">
                                <div className="justify-center mx-auto rounded py-4 px-2" style={{ border: '1px solid #0047ab' }}>
                                    <img src={Cleaning} alt="" className="w-12 flex justify-center mx-auto" />
                                    <p className="text-center xl:text-xl text-lg font-semibold pt-3">
                                        Tank Safety and
                                        Cleaning Systems
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}





            <section className="bg-white ">
                <div className="container mx-auto xl:py-16 py-12 xl:px-0 px-4">
                    <h6 className="text-center text-blue text-base uppercase font-semibold">
                        Overview
                    </h6>
                    <h3 className="text-black xl:text-4xl lg:text-3xl md:text-3xl text-2xl font-semibold text-center">
                    Evoguard valves and pumps 
                    </h3>
                    <p className="text-gray font-semibold text-base mt-4 text-center">
                   The Evoguard valve and pump series comprises a modular system of components that contributes to a high performance all over your production line.</p>
                                
                    <div className="grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-4 pt-12">
                        <div className="h-full">
                            
                                <div className="justify-center mx-auto rounded  headerbg1 xl:p-6 p-4 h-full">
                                    <img src={m1} alt="" className="" />
                                    <p className=" xl:text-lg text-base font-semibold pt-3">
                                    Hygienic valves
                                        <p className="text-gray font-semibold text-base mt-4">Hygienic valves ensure sanitary flow control in food, beverage, and pharmaceutical processing.</p>
                                    </p>
                                    <a href="https://www.evoguard.com/en/">
                    <h1 className="xl:mt-6 lg:mt-4 mt-2 text-black font-bold">
                      Learn More ≫
                    </h1>
                  </a>
                                </div>
                           
                        </div>
                        <div className="h-full">
                            
                                <div className="justify-center mx-auto rounded xl:p-6 p-4 headerbg1 h-full">
                                    <img src={m2} alt="" className="" />
                                    <p className=" xl:text-lg font-semibold text-base  pt-3">
                                    Pumps
                                        <p className=" text-base mt-4">Pumps move liquids efficiently through processing systems in various industrial applications.</p>
                                    </p>
                                    <a href="https://www.evoguard.com/en/">
                    <h1 className="xl:mt-6 lg:mt-4 mt-2 text-black font-bold">
                      Learn More ≫
                    </h1>
                  </a>
                                </div>
                            
                        </div>
                        <div className="h-full">
                            
                                <div className="justify-center mx-auto rounded xl:p-6 p-4 headerbg1 h-full">
                                    <img src={m3} alt="" className="" />
                                    <p className=" xl:text-lg text-base font-semibold  pt-3">
                                    Aseptic valves
                                        <p className=" text-base mt-4">Aseptic valves ensure sterile flow control in hygienic processing environments.</p>
                                    </p>
                                    <a href="https://www.evoguard.com/en/">
                    <h1 className="xl:mt-6 lg:mt-4 mt-2 text-black font-bold">
                      Learn More ≫
                    </h1>
                  </a>
                                </div>
                            
                        </div>
                        <div className="h-full">
                            
                                <div className="justify-center mx-auto rounded xl:p-6 p-4 headerbg1 h-full">
                                    <img src={m4} alt="" className="" />
                                    <p className=" xl:text-lg font-semibold text-base  pt-3">
                                    Vessel dome fittings
                                        <p className="  text-base mt-4">Vessel dome fittings provide hygienic access and connections on processing vessels.</p>
                                    </p>
                                    <a href="https://www.evoguard.com/en/">
                    <h1 className="xl:mt-6 lg:mt-4 mt-2 text-black font-bold">
                      Learn More ≫
                    </h1>
                  </a>
                                </div>
                            
                        </div>
                    </div>
                </div>
            </section>



            {/* <section className="headerbg1 ">
                <div className="container mx-auto xl:py-16 py-12 xl:px-0 px-4">
                    <div className="flex flex-wrap items-center">
                        <div className="xl:w-5/12 lg:w-5/12 md:w-5/12 w-full">
                            <h4 className="text-xl text-blue font-semibold uppercase">
                                Evoguard
                            </h4>
                            <h1 className="text-black xl:text-5xl lg:text-4xl md:text-3xl text-2xl font-semibold py-2">
                                Tank Safety  and Cleaning Systems
                            </h1>
                        </div>
                        <div className="xl:w-7/12 lg:w-7/12 md:w-7/12 w-full">
                            <div className="flex flex-wrap items-center py-4">
                                <p className="w-2/12 text-blue text-4xl font-semibold">
                                    V1
                                </p>
                                <h2 className="w-10/12 text-black xl:text-xl xl:pl-6 pl-4">
                                    Switch over CIP / gas, automatic without energy
                                    - EVOGUARD switch module
                                </h2>
                            </div>

                            <div className="flex flex-wrap items-center py-4">
                                <p className="w-2/12 text-blue text-4xl font-semibold">
                                    V2
                                </p>
                                <h2 className="w-10/12 text-black xl:text-xl xl:pl-6 pl-4">
                                    Switch over CIP / gas, with power supply pneumatic
                                    - EVOGUARD Butterfly valve
                                </h2>
                            </div>

                            <div className="flex flex-wrap items-center py-4">
                                <p className="w-2/12 text-blue text-4xl font-semibold">
                                    V3
                                </p>
                                <h2 className="w-10/12 text-black xl:text-xl xl:pl-6 pl-4">
                                    Switch over CIP / gas, with power supply pneumatic
                                    - EVOGUARD Divert valve
                                </h2>
                            </div>

                            <div className="flex flex-wrap items-center py-4">
                                <p className="w-2/12 text-blue text-4xl font-semibold">
                                    V4
                                </p>
                                <h2 className="w-10/12 text-black xl:text-xl xl:pl-6 pl-4">
                                    Gas pressure control, with power supply electropneumatic
                                    - EVOGUARD Control valve, electropneumatic
                                </h2>
                            </div>

                        </div>
                    </div>
                </div>
            </section> */}

            <section className=" ">
                <div
                    className="xl:py-16 py-12 "
                    style={{
                        backgroundImage: `url(${bg})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                    }}
                >
                    <div className="container mx-auto ">
                        <h6 className="text-center text-xl uppercase font-semibold" style={{ color: '#fe0000' }}>
                            Evoguard
                        </h6>
                        <h3 className="text-white xl:text-4xl lg:text-4xl text-3xl font-semibold text-center">
                        Vessel dome fittings

                        </h3>
                        <p className="text-center text-white xl:text-xl xl:w-7/12 lg:w-7/12 md:w-10/12 w-full mx-auto py-2 xl:px-0 lg:px-0 md:px-0 px-4">
                        Tank safety and cleaning systems are needed to help manage the flow of product, gasses or cleaning fluids in highly automated systems.
                        </p>
                        <div className="flex flex-wrap gap-3 ">
                            <div className="xl:w-3/12 lg:w-3/12 md:w-0/12 pt-6 lg:pt-8 xl:pt-8 md:pt-4">
                            </div>
                            <div className="xl:w-3/12 lg:w-3/12 md:w-4/12 lg:pt-8 md:pt-6  xl:pt-8 pt-6 xl:ml-0 lg:ml-0 ml-0 md:ml-24" >
                                <div className="xl:p-6 lg:p-4 p-4 rounded" >
                                    <h4 className="xl:text-2xl lg:text-2xl text-xl text-white pb-2 font-semibold" >
                                    One fitting, three functions
                                    </h4>
                                    <div className="flex items-center gap-3 py-3">
                                        <i className="fas fa-arrow-right text-sm" style={{ color: '#fe0000' }}></i>
                                        <p className="text-white xl:text-xl text-xl">
                                        Protection of the tanks against damage due to overpressure
                                        </p>
                                    </div>
                                    <div className="flex items-center gap-3 py-3">
                                        <i className="fas fa-arrow-right text-blue text-sm" style={{ color: '#fe0000' }}></i>
                                        <p className="text-white xl:text-xl text-xl">
                                        Tank cleaning
                                        </p>
                                    </div>
                                    <div className="flex items-center gap-3 py-3">
                                        <i className="fas fa-arrow-right text-blue text-sm" style={{ color: '#fe0000' }}></i>
                                        <p className="text-white xl:text-xl text-xl">
                                        Control of gasses during the process
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="xl:w-3/12 lg:w-3/12 md:w-3/12 lg:pt-8  xl:pt-8 md:pt-6 pt-0 xl:pl-0 lg:pl-0 md:pl-0 pl-4">
                                <div className="xl:p-6 lg:p-4 p-4 rounded" >
                                    <h4 className="xl:text-2xl lg:text-2xl text-xl text-white pb-2 font-semibold">
                                    Overview of the technology
                                    </h4>
                                    <div className="flex items-center gap-3 py-3">
                                        <i className="fas fa-arrow-right text-blue text-sm" style={{ color: '#fe0000' }}></i>
                                        <p className="text-white xl:text-xl text-xl">
                                        Configuration according to product
                                        </p>
                                    </div>
                                    <div className="flex items-center gap-3 py-3">
                                        <i className="fas fa-arrow-right text-blue text-sm" style={{ color: '#fe0000' }}></i>
                                        <p className="text-white xl:text-xl text-xl" >
                                        Compact unit
                                        </p>
                                    </div>
                                    <div className="flex items-center gap-3 py-3">
                                        <i className="fas fa-arrow-right text-blue text-sm" style={{ color: '#fe0000' }}></i>
                                        <p className="text-white xl:text-xl text-xl">
                                        Cost savings
                                        </p>
                                    </div>
                                    <div className="flex items-center gap-3 py-3">
                                        <i className="fas fa-arrow-right text-blue text-sm" style={{ color: '#fe0000' }}></i>
                                        <p className="text-white xl:text-xl text-xl" >
                                        Easy installation and dismantling
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="xl:w-3/12 lg:w-3/12 md:w-3/12 w-full"></div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </section>
    );
};

export default Evoguard;
